"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.withEDSContext = exports.EDSContext = exports.DEFAULT_LOCALE = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _i18n = require("@ellucian/react-design-system/core/i18n");
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _lodash = require("lodash");
// context that tracks common information, available to all components
var EDSContext = exports.EDSContext = /*#__PURE__*/_react.default.createContext({});
var DEFAULT_LOCALE = exports.DEFAULT_LOCALE = 'en-US';
function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

/**
 * Wraps the given component in an HOC that provides global information to all EDS components.
 *
 * It injects an edsContextInfo property, which contains the follow attributes:
 *
 * * formatMessage: (function) Returns the text corresponding to a given id. Accepts two arguments:
 *     - id: The id of the message to include
 *     - substitutions: (optional) An object that specifies substitutions for templated resources.
 *
 * * locale: (string) The locale specified at the EDSApplication level.
 *
 * * dir: ('rtl' or 'ltr') The directionality of the application.
 *
 * * platform: ('web' or 'mobile') Renders components with corresponding web or mobile variant.
 *
 * @param {Component} WrappedComponent The component to wrap
 */
var withEDSContext = exports.withEDSContext = function withEDSContext(WrappedComponent) {
  var getFormatMessageFunc = function getFormatMessageFunc(_ref) {
    var locale = _ref.locale,
      labelOverrides = _ref.labelOverrides;
    var messagesLocale = (locale != null ? locale : DEFAULT_LOCALE).replace('-', '_');
    var messages = _i18n.i18n[messagesLocale].messages;
    if (!(0, _lodash.isEmpty)(labelOverrides)) {
      messages = Object.assign({}, messages, labelOverrides);
    }
    var f = function f(id, substitutions) {
      var msg = messages[id];

      // if we found a resource for this id, handle substitutions
      if (msg) {
        if (substitutions) {
          Object.keys(substitutions).forEach(function (key) {
            msg = msg.replace("{" + key + "}", substitutions[key]);
          });
        }
      } else {
        // Display key as it is if value is not available in the locale file.
        msg = "MISSING KEY: " + id;
        console.error("MISSING KEY: " + id);
      }
      return msg;
    };
    return f;
  };
  var wrap = /*#__PURE__*/_react.default.forwardRef(function contextTranslation(props, ref) {
    return /*#__PURE__*/_react.default.createElement(EDSContext.Consumer, null, function (value) {
      return /*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({
        ref: ref
      }, props, {
        edsContext: {
          dir: value.dir,
          formatMessage: getFormatMessageFunc(value),
          locale: value.locale,
          platform: value.platform
        }
      }));
    });
  });
  wrap.displayName = "EDSContext(" + getDisplayName(WrappedComponent) + ")";
  return (0, _hoistNonReactStatics.default)(wrap, WrappedComponent);
};